import { useEffect } from 'react';
import { supabase } from '../lib/supabase';

function AuthCallbackPage() {
  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();

        if (error) {
          console.error('Erreur lors de la récupération de la session:', error);
        } else if (data.session) {
          console.warn('Session récupérée avec succès:', data.session.user.email);
        }
      } catch (error) {
        console.error('Erreur lors du traitement du callback:', error);
      }
    };

    handleAuthCallback();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
        <p className="text-gray-600">Connexion en cours...</p>
      </div>
    </div>
  );
}

export default AuthCallbackPage;
